import { useEffect, useState } from "react";
import SearchSkillsOptions from "./SearchSkillOptions";
import SearchSkillsResults from "./SearchSkillsResults";
import SelectRoleNavigation from "./SelectRoleNavigation";

import { API_BASE_URL } from "../../config";

export default function SearchSkills({
  handleDecrement,
  handleIncrement,
  num,
  handleResults,
}) {
  const [checkValidation, setCheckValidation] = useState(true);
  const [resultsValues, setResultsValues] = useState("");
  const [results, setResults] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedJobTypes, setSelectedJobTypes] = useState([]);

  const handleJobCategories = (value) => {
    setResultsValues(value);
  };

  const handleSelectedSkills = (value) => {
    setSelectedSkills(value);

    if (!results || results.length === 0) return;

    const updatedJobTypes = [...selectedJobTypes];

    const hasSelectedSkill = results.some((jobTypeCategory) =>
      jobTypeCategory.skills.some((skill) => value.includes(String(skill.id)))
    );

    if (hasSelectedSkill) {
      if (!updatedJobTypes.includes(resultsValues)) {
        updatedJobTypes.push(resultsValues);
      }
    } else {
      const index = updatedJobTypes.indexOf(resultsValues);
      if (index != -1) {
        updatedJobTypes.splice(index, 1);
      }
    }

    if (updatedJobTypes.length > 0) {
      setCheckValidation(false);
    } else {
      setCheckValidation(true);
    }

    setSelectedJobTypes(updatedJobTypes);
  };

  const handleJobCategoriesSearch = () => {
    setResults("");
  };

  useEffect(() => {
    if (!resultsValues) return;

    const fetchJobCategories = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}/job-types/${resultsValues}/skill-categories`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch job categories");
        }
        const data = await response.json();

        setResults(data.data);
      } catch (error) {
        console.log("Error fetching job categories:", error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchJobCategories();
  }, [resultsValues]);

  return (
    <>
      <SelectRoleNavigation
        currentStep={num}
        handleDecrement={handleDecrement}
        handleIncrement={handleIncrement}
        title="Select a skills that you are looking for"
        text="One or multiple selection"
        validationButton={checkValidation}
      />

      <div className="search-skills-wrapper">
        <div className="container">
          <div className="search-skills">
            <div className="row-essy">
              <div className="col-essy-md-6 col-essy-lg-6">
                <SearchSkillsOptions
                  handleCategories={handleJobCategories}
                  handleCategoriesSearch={handleJobCategoriesSearch}
                  selectedJobTypes={selectedJobTypes}
                />
              </div>
              <div className="col-essy-md-6 col-essy-lg-6">
                <SearchSkillsResults
                  handleSelectedSkills={handleSelectedSkills}
                  results={results}
                  isLoading={isLoading}
                  selectedSkills={selectedSkills}
                  handleResults={handleResults}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
